export default __webpack_public_path__ + "static/media/87g.f515cc05.svg";